<template>
  <el-header style="height:66px;padding:0;">
    <!-- 左侧区域 -->
    <div class="head_l_part">
    <el-link v-if="emailLogo" href="javascript:;" @click.native="goToInfo" :underline="false" class="custom_logo"><img :src="'data:image/png;base64,'+emailLogo"></el-link>
    <el-link v-if="!emailLogo" href="javascript:;" @click.native="goToInfo" :underline="false" class="logo"></el-link>
    <div class="searchBlock">
      <span class="s_input"><input class="iptTxt" type="text" v-model="searchKey" @keyup.enter="searchMailAddr" :placeholder="searchPlaceholder"></span>
      <span class="s_btn" @click.stop="searchMailAddr"><i class="el-icon-search searchBtn"></i></span>
      <span class="s_arrow" @click.stop="detailSearchPanel"><i class="el-icon-caret-bottom arrowBtn"></i></span>
    </div>
    <!-- 邮件搜索弹框 -->
    <div id="mailSearchBox" class="popBox searchBox" v-if="currPageName !== 'address'" v-show="searchMailShow">
      <div class="mailSearch" v-show="!advSearchShow">
      <ul class="bLine">
        <li @click="mailListSearch('all')" class="searchMoreText all clearfix" style="display: list-item;"><h3>&nbsp;</h3><h4>{{$t("wm_lang_html_e13556")}}<span class="blue3">{{searchKey}}</span>{{$t("wm_lang_html_a7a6eb")}}</h4> </li>
        <li @click="mailListSearch('sender')" class="searchMoreText sender clearfix" style="display: list-item;"><h3>{{$t("wm_lang_html_88c952")}}</h3><h4>{{$t("wm_lang_html_e13556")}}<span class="blue3">{{searchKey}}</span>{{$t("wm_lang_html_a7a6eb")}}</h4> </li>
        <li @click="mailListSearch('topic')" class="searchMoreText topic clearfix" style="display: list-item;"><h3>{{$t("wm_lang_html_7bbc73")}}</h3><h4>{{$t("wm_lang_html_e13556")}}<span class="blue3">{{searchKey}}</span>{{$t("wm_lang_html_a7a6eb")}}</h4></li>
        <li @click="mailListSearch('receiver')" class="searchMoreText receiver clearfix" style="display: list-item;"><h3>{{$t("wm_lang_html_fb5bf1")}}</h3><h4>{{$t("wm_lang_html_e13556")}}<span class="blue3">{{searchKey}}</span>{{$t("wm_lang_html_a7a6eb")}}</h4></li>
        <!--<li @click="mailListSearch('text')" class="searchMoreText text clearfix fullsearch yunYingShang_hide mixedCloud_hide rzrq_hide"><h3>{{$t("wm_lang_html_58378f")}}</h3><h4>{{$t("wm_lang_html_e13556")}}<span class="blue3">{{searchKey}}</span>{{$t("wm_lang_html_a7a6eb")}}</h4></li>-->
        <li @click="mailListSearch('attach')" class="searchMoreText affixName clearfix fullsearch yunYingShang_hide mixedCloud_hide rzrq_hide"><h3>{{$t("wm_lang_html_f5de9e")}}</h3><h4>{{$t("wm_lang_html_e13556")}}<span class="blue3">{{searchKey}}</span>{{$t("wm_lang_html_a7a6eb")}}</h4></li>
      </ul>
      <h2 class="showSuperTxt"><a href="#" class="showSuper" @click.stop="showAdvSearch">{{$t("wm_lang_html_092ba7")}}</a></h2>
      </div>
      <!-- 高级搜索 -->
      <div class="superSearch" v-show="advSearchShow">
        <el-form ref="form" :model="form" label-width="86px" size="mini" label-position="left">
          <el-form-item :label="$i18n.t('wm_lang_092ba7')">
            <!--<el-select v-model="form.searchFolder" placeholder=this.$i18n.t('wm_lang_6732fd')>-->
              <!--<el-option label=this.$i18n.t('wm_lang_e75969') value="1"></el-option>-->
              <!--<el-option label=this.$i18n.t('wm_lang_93d159') value="2"></el-option>-->
              <!--<el-option label=this.$i18n.t('wm_lang_5cc232') value="3"></el-option>-->
              <!--<el-option label=this.$i18n.t('wm_lang_22b433') value="4"></el-option>-->
              <!--<el-option label=this.$i18n.t('wm_lang_0bb8f9') value="5"></el-option>-->
              <!--<el-option label=this.$i18n.t('wm_lang_c3ba16') value="6"></el-option>-->
            <!--</el-select>-->
            <el-select v-model="form.searchFolder" :placeholder="$i18n.t('wm_lang_6732fd')">
              <!--<el-option label=this.$i18n.t('wm_lang_c2b9f4') :value="0"></el-option>-->
              <!--<el-option label=this.$i18n.t('wm_lang_6732fd')></el-option>-->
              <el-option v-for="(item, index) in form.folders" :key="index" :label="item.displayName" :value="item.folderId" style="max-width:193px;"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$i18n.t('wm_lang_88c952')">
            <el-input v-model="form.sender"></el-input>
          </el-form-item>
          <el-form-item :label="$i18n.t('wm_lang_fb5bf1')">
            <el-input v-model="form.receiver"></el-input>
          </el-form-item>
          <el-form-item :label="$i18n.t('wm_lang_9970ad')">
            <el-input v-model="form.topic"></el-input>
          </el-form-item>
          <el-form-item :label="$i18n.t('wm_lang_d1a00e')">
            <el-input v-model="form.attachName"></el-input>
          </el-form-item>
          <el-form-item :label="$i18n.t('wm_lang_cd649f')">
             <el-date-picker
              v-model="form.timeSpans"
              style="width:100%;"
              type="daterange"
              value-format="timestamp"
              :range-separator="$i18n.t('wm_lang_981cbe')"
              :start-placeholder="$i18n.t('wm_lang_b44c0f')"
              :end-placeholder="$i18n.t('wm_lang_1d468b')"
              :default-time="['00:00:00', '23:59:59']">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$i18n.t('wm_lang_60ae02')">
            <el-select v-model="form.selectAttach" :placeholder="$i18n.t('wm_lang_8441b3')">
              <el-option :label="$i18n.t('wm_lang_8441b3')" value="1"></el-option>
              <el-option :label="$i18n.t('wm_lang_e13556')" value="2"></el-option>
              <el-option :label="$i18n.t('wm_lang_da0291')" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$i18n.t('wm_lang_8ad629')+'/'+this.$i18n.t('wm_lang_894a10')">
            <el-select v-model="form.selectStatus" :placeholder="$i18n.t('wm_lang_8441b3')">
              <el-option :label="$i18n.t('wm_lang_8441b3')" value="1"></el-option>
              <el-option :label="$i18n.t('wm_lang_8ad629')" value="2"></el-option>
              <el-option :label="$i18n.t('wm_lang_894a10')" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click.stop="advancedSearch">{{$t("wm_lang_html_e5f71f")}}</el-button>
            <el-button @click.stop="advancedCancel">{{$t("wm_lang_html_625fb2")}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 通讯录搜索弹框 -->
    <div class="popBox searchBox_address" v-if="currPageName === 'address'" v-show="searchAddressShow">
        <ul class="mailSearch sLine">
          <li class="searchMoreText qy clearfix" @click="searchAddrOrg">
            <h3>{{$t("wm_lang_html_d43e13")}}</h3>
            <h4>{{$t("wm_lang_html_e13556")}}<span class="blue3">{{searchKey}}</span>{{$t("wm_lang_html_93d79c")}}</h4>
          </li>
          <li class="searchMoreText gr clearfix" @click="searchAddrPers">
            <h3>{{$t("wm_lang_html_d3298c")}}</h3>
            <h4>{{$t("wm_lang_html_e13556")}}<span class="blue3">{{searchKey}}</span>{{$t("wm_lang_html_93d79c")}}</h4>
          </li>
          <!--<li class="searchMoreText gr clearfix" @click="searchMaillist">-->
            <!--<h3>{{$t("wm_lang_html_6b0fd2")}}</h3>-->
            <!--<h4>{{$t("wm_lang_html_e13556")}}<span class="blue3">{{searchKey}}</span>{{$t("wm_lang_html_6219c6")}}</h4>-->
          <!--</li>-->
        </ul>
     </div>
    </div>
    <!-- 右侧区域 -->
    <div class="head_r_part">
      <ul class="nav">
        <li :class="this.$route.path === '/home/info' ?  'selected' : ''">
          <!--<router-link to="/home/info">-->
            <el-link href="javascript:;" @click.native="goToInfo" :underline="false" class="home" :title="$i18n.t('wm_lang_db1c89')"></el-link>
          <!--</router-link>-->
        </li>
        <li :class="this.$route.path === '/home/mail/read' ?  'selected' : ''">
          <!--<router-link to="/home/mail">-->
            <el-link href="javascript:;" @click.native="toMailList" :underline="false" class="mail" :title="$i18n.t('wm_lang_3bc5e6')"></el-link>
          <!--</router-link>-->
        </li>
        <li :class="this.$route.path === '/address' ?  'selected' : ''">
          <el-link href="javascript:;" @click.native="toAddress" :underline="false" class="address" :title="$i18n.t('wm_lang_183abe')"></el-link>
        </li>
        <li v-if="calendarEnable"><el-link href="javascript:;" @click.native="toCalendar" :underline="false" class="calendarLink" :title="$i18n.t('wm_lang_c6cceb')"></el-link></li>
        <!--<li><el-link href="javascript:;" :underline="false" class="cloudViewLink" title=this.$i18n.t('wm_lang_19cd24')></el-link></li>-->
        <!--<li><el-link href="javascript:;" :underline="false" class="netSave" title=this.$i18n.t('wm_lang_67bc37')></el-link></li>-->
        <!--<li><el-link href="javascript:;" :underline="false" class="OCS" title=this.$i18n.t('wm_lang_7f72e8')></el-link></li>-->
      </ul>
      <div class="float-l headLeft_border">
      <el-dropdown size="small" trigger="click">
      <el-link href="#" :underline="false" class="txtArr"><img style="width:52px;height:52px;" src="~@/assets/images/3ea6beec64369c2642b92c6726f1epng.png"><i class="el-icon-more float-r c_white mt15 f20"></i></el-link>
      <el-dropdown-menu slot="dropdown" class="el-dropdown-ej">
        <div class="profileTitle">
          <p class="headPic"><img class="userIcon" src="~@/assets/images/3ea6beec64369c2642b92c6726f1epng.png"></p>
          <div class="intro">
              <p class="flexBetween"><b class="userName w124 cutout">{{localUserInfo.userName}}</b><el-link href="#" :underline="false" @click.native="goAccount"><i class="el-icon-edit f14 rzrq_hide"></i></el-link></p>
              <p class="wid">{{localUserInfo.userEmail}}</p>
          </div>
        </div>
        <!--<el-dropdown-item>{{$t("wm_lang_html_0be5a1")}}<i class="el-icon-arrow-right el-icon&#45;&#45;right"></i>-->
            <!--<div class="el-dropdown-menu-ej">-->
              <!--<ul class="el-dropdown-menu el-dropdown-menu-left">-->
               <!--<li class="el-dropdown-menu__item">{{$t("wm_lang_html_0d8f65")}}</li>-->
               <!--<li class="el-dropdown-menu__item">{{$t("wm_lang_html_992cd2")}}</li>-->
               <!--<li class="el-dropdown-menu__item">{{$t("wm_lang_html_5f10ee")}}</li>-->
               <!--<li class="el-dropdown-menu__item">{{$t("wm_lang_html_66c3e5")}}</li>-->
               <!--<li class="el-dropdown-menu__item">{{$t("wm_lang_html_d3950d")}}</li>-->
               <!--<li class="el-dropdown-menu__item">{{$t("wm_lang_html_0807a3")}}</li>-->
               <!--<li class="el-dropdown-menu__item">{{$t("wm_lang_html_0182f1")}}</li>-->
               <!--<li class="el-dropdown-menu__item">{{$t("wm_lang_html_abb501")}}</li>-->
               <!--<li class="el-dropdown-menu__item sortDot">{{$t("wm_lang_html_c33c30")}}</li>-->
              <!--</ul>-->
            <!--</div>-->
        <!--</el-dropdown-item>-->
        <el-dropdown-item>{{$t("wm_lang_html_5aefca")}}<i class="el-icon-arrow-right el-icon--right"></i>
            <div class="el-dropdown-menu-ej">
              <ul class="el-dropdown-menu el-dropdown-menu-left">
               <li :class="setValueLayout === 'lr' ? 'el-dropdown-menu__item sortDot' : 'el-dropdown-menu__item'" @click="setLayout('lr')">{{$t("wm_lang_html_ac8ccc")}}</li>
               <li :class="setValueLayout === 'tb' ? 'el-dropdown-menu__item sortDot' : 'el-dropdown-menu__item'" @click="setLayout('tb')">{{$t("wm_lang_html_f1d5f5")}}</li>
              </ul>
            </div>
        </el-dropdown-item>
        <!--<el-dropdown-item>{{$t("wm_lang_html_92e3a8")}}</el-dropdown-item>-->
        <el-dropdown-item divided @click.native="goSetting">{{$t("wm_lang_html_e366cc")}}</el-dropdown-item>
        <el-dropdown-item @click.native="logout">{{$t("wm_lang_html_c39922")}}</el-dropdown-item>
      </el-dropdown-menu>
      </el-dropdown>
      </div>
    </div>
  </el-header>
</template>

<script>
import Cookies from 'js-cookie';
import storeLocal from 'store';
import xmail from '@/api/api';
import moment from 'moment';
import { getFolderPathName } from '@/utils/utils';
export default {
  name: 'Header',
  data () {
    return {
      msgindex: this.$i18n.t('wm_lang_5f4fd0'),
      emailLogo: '',
      calendarEnable: false,
      circleUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      localUserInfo: '',
      // localHomeInfo: '',
      localConfigSetting: {},
      value1: '',
      setValueLayout: '',
      fromPageName: '',
      currPageName: '',
      searchMailShow: false,
      searchAddressShow: false,
      advSearchShow: false,
      searchPlaceholder: this.$i18n.t('wm_lang_80c18f')+'...',
      searchKey: '',
      form: {
        folders: [],
        sender: '',
        receiver: '',
        topic: '',
        attachName: '',
        searchFolder: '',
        selectAttach: '',
        selectStatus: '',
        // timeSpans: [parseInt(moment().subtract(1, 'months').format('x')), new Date().getTime()]
        timeSpans: [parseInt(moment().subtract(1, 'months').startOf('day').format('x')), parseInt(moment().endOf('day').format('x'))]
      }
    }
  },
  watch: {
    $route(to, from) {
      // console.log(to);
      // console.log(from);
      this.searchKey = '';
      this.fromPageName = from.name;
      this.currPageName = to.name;
      if(to.name === 'address') {
        this.searchPlaceholder = this.$i18n.t('wm_lang_7c6a2c')
      } else {
        this.searchPlaceholder = this.$i18n.t('wm_lang_80c18f')+'...'
      }
      this.setValueLayout = Cookies.get('Pwm-set-layout') ? Cookies.get('Pwm-set-layout') : 'lr';
    }
  },
  mounted() {
    let self = this;
    //初始化页头事件总线
    this.$EventBus.$off("getInitHeader");
    this.$EventBus.$on("getInitHeader",function(){
      self.initHeader();
    });
    if (storeLocal.get('Pwm-Islogin')) {
      this.initHeader()
    }
  },
  methods: {
    initHeader() {
      //设置初始化
      this.setValueLayout = Cookies.get('Pwm-set-layout') ? Cookies.get('Pwm-set-layout') : 'lr';
      console.log(this.setValueLayout);
      //全局点击隐藏搜索框
      this.$globalClick(() => {
        this.searchAddressShow = false;
        this.searchMailShow = false;
      }, 'app', 'mailSearchBox');
      //用户信息
      this.localUserInfo = storeLocal.get('Pwm-userInfo');
      //首页信息
      // this.localHomeInfo = storeLocal.get('Pwm-homeInfo');
      //设置信息
      this.localConfigSetting = storeLocal.get('Pwm-configSetting');
      this.emailLogo = this.localConfigSetting.displaySetting.emailLogo;
      this.calendarEnable = this.localConfigSetting.displaySetting.calendarEnable;
    },
    goSetting() {
      this.$router.push({name: 'setting', params: {activeIndex: '4'}});
    },
    goAccount() {
      this.$router.push({name: 'userInfo', params: {activeIndex: '1'}});
    },
    goToInfo() {
      this.$router.push({name: 'info'});
      this.$EventBus.$emit("setFolderHighlight", null);
      if(this.fromPageName === 'write') {
        this.$EventBus.$emit("changeTabDraftSave");
      }
    },
    advancedSearch() {
      // console.log(this.$route.name);
      if(this.$route.name !== 'read') {
        this.$EventBus.$emit("filterCurrIndex",{search: {scope: 'advanced', keyObj: this.form}});
        this.$router.push({name: 'read'});
      } else {
        this.$EventBus.$emit("filterCurrIndex",{search: {scope: 'advanced', keyObj: this.form}});
      }
      this.searchMailShow = false;
    },
    advancedCancel() {
      this.searchMailShow = false;
    },
    getFolders() {
      let formFolders = JSON.parse(JSON.stringify(this.$store.getters.folders));
      formFolders = formFolders.filter(item => item.folderId !== xmail.enums.FolderType.STAR_BOX_FOLDER_ID && item.folderId !== xmail.enums.FolderType.WAITING_BOX_FOLDER_ID)
      this.form.folders = getFolderPathName(formFolders);
      // console.log(this.form.folders)
    },
    /**
     * 搜索邮件路由跳转及触发事件总线方法
     * @method
     * @for mailListSearch
     * @param {scope} 搜索范围
     * @return {无}
     */
    searchMailHandle(scope) {
      if(this.$route.name !== 'read') {
        this.$EventBus.$emit("filterCurrIndex",{search: {scope: scope, key: this.searchKey}});
        this.$router.push({name: 'read'});
      } else {
        this.$EventBus.$emit("filterCurrIndex",{search: {scope: scope, key: this.searchKey}});
      }
      this.searchMailShow = false;
    },
    mailListSearch(type) {
      switch (type) {
        case 'all':
          this.searchMailHandle('all');
          break;
        case  'sender':
          this.searchMailHandle('sender');
          break;
        case 'topic':
          this.searchMailHandle('topic');
          break;
        case 'receiver':
          this.searchMailHandle('receiver');
          break;
        case 'text':
          this.searchMailHandle('text');
          break;
        case 'attach':
          this.searchMailHandle('attach');
          break;
        default:
          //
      }
    },
    showAdvSearch() {
      this.searchKey = '';
      this.advSearchShow = true;
    },
    detailSearchPanel() {
      this.getFolders();
      if(this.currPageName === 'address') {
        if(this.searchKey === '') {
          return;
        }
        this.searchAddressShow = !this.searchAddressShow;
      } else {
        this.searchMailShow = !this.searchMailShow;
        this.advSearchShow = this.searchKey === '';
      }
    },
    searchAddrOrg() {
      this.$EventBus.$emit("searchOrgAddrResult", this.searchKey);
      this.searchAddressShow = false;
    },
    searchAddrPers() {
      this.$EventBus.$emit("searchPersAddrResult", this.searchKey);
      this.searchAddressShow = false;
    },
    // searchMaillist() {
    //   // this.$EventBus.$emit("searchMaillistResult", this.searchKey);
    // },
    searchMailAddr() {
      if(this.searchKey === '') {
        return;
      }
      if(this.currPageName === 'address') {
        this.$EventBus.$emit("searchOrgAddrResult", this.searchKey);
      } else {
        this.searchMailHandle('all');
      }
    },
    toMailList(data) {
      let currFolder = this.$store.getters.folderId;
      let currFolderName = this.$store.getters.folderName;
      // console.log(currFolderName);
      if(currFolder){
        // this.$EventBus.$emit("getCurrFid",currFolder);
        // this.$store.commit('SET_FOLDER_ID',currFolder);
        // this.$store.commit('SET_FOLDER_NAME',currFolderName);
        this.$router.push({path:'/home/mail'});
        // this.$router.push({name:'read',params: {toType:'header'}})
      } else {
        this.$store.commit('SET_FOLDER_ID',1);
        this.$store.commit('SET_FOLDER_NAME',this.$i18n.t('wm_lang_e75969'));
        // this.$EventBus.$emit("getCurrFid",1);
        this.$router.push({path:'/home/mail'});
        // this.$router.push({name:'read',params: {toType:'header'}})
      }
    },
    toCalendar() {
      window.open('/xmail/udcd/v1/sso/calSsoLogin' + storeLocal.get('Pwm-urlParams'));
    },
    toAddress(data) {
      this.$router.push({name:'address', params: {headerGo: true}});
    },
    setLayout(type) {
      // this.setValueLayout = type;
      // Cookies.set('Pwm-set-layout',type);
      let layoutType = '';
      if(type === 'lr') {
        layoutType = xmail.enums.Layout.LR;
      } else {
        layoutType = xmail.enums.Layout.LIST
      }
      let self = this;
      (function (api, enums, pms) {
        let pm = pms.Setting.updateLayoutParamBuilder();
        pm.layout = layoutType;
        api.Setting.updateLayout(pm, function (res) {
          if(res.data.code === 0) {
            Cookies.set('Pwm-set-layout',type);
            self.setValueLayout = type;
            self.$router.push({path:'/home/mail'});
            self.$EventBus.$emit("changeListLayoutSet",{layout: type});
            self.$EventBus.$emit("changeReadLayoutSet",{layout: type});
            self.$EventBus.$emit("changeMailLayoutSet",{layout: type});
            if(self.$store.getters.folderId === enums.FolderType.DRAFT_BOX_FOLDER_ID) {
              self.$store.commit('SET_CHECKED_MAILS',[])
            }
          }
        })
      })(xmail.api, xmail.enums, xmail.pms);
      // this.$router.push({path:'/home/mail'});
      // this.$EventBus.$emit("changeListLayoutSet",{layout: type});
      // this.$EventBus.$emit("changeReadLayoutSet",{layout: type});
      // this.$EventBus.$emit("changeMailLayoutSet",{layout: type});
      // if(type === 'lr'){
      //   this.$router.push({path:'/home/mail'});
      // }
      // if(type === 'tb'){
      //   this.$router.push({path:'/home/table'});
      // }
    },
    logout() {
      // console.log(storeLocal.get('Pwm-configSetting'))
      let configSetting = storeLocal.get('Pwm-configSetting');
      let logoutUrl = configSetting ? configSetting.displaySetting.logoutUrl : '';
      this.$store.dispatch('LogOut').then(() => {
        if(logoutUrl) {
          location.href = logoutUrl;
        } else {
          // location.reload();
          window.location.href = '/login/';
          //开发环境退出地址
          // window.location.href = '/smailLogin';
        }
        // location.reload();
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-header{color:#fff;}
.searchMoreText{ cursor: pointer}
</style>



// WEBPACK FOOTER //
// src/components/sub/Header.vue